import { WarningOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { ReportLoadStatus } from "../../../store";
import BugReportButton from "../BugReportButton";
import FileUploadButton from "../FileUploadButton";
import ShareButton from "../ShareButton";

interface UrlAnalysisHeaderProps {
  scanId: string;
  loadStatus: ReportLoadStatus;
  errorMsg: string | null;
}

const UrlAnalysisHeader: React.FC<UrlAnalysisHeaderProps> = ({
  scanId,
  loadStatus,
  errorMsg,
}) => {
  const isLoaded = loadStatus === ReportLoadStatus.REPORT_LOADED;
  const isError = loadStatus === ReportLoadStatus.ERROR_LOADING_REPORT;

  return (
    <div className="flex-column">
      <div className="flex-space-between main-navbar">
        <h1 className="main-title-text" id="h1-title">
          URL Analysis Report
        </h1>
        <div className="upload-section">
          <BugReportButton />
          <ShareButton analysisId={scanId} />
          <FileUploadButton disabled={!isLoaded} />
        </div>
      </div>
      <p className="main-text">
        Fast and scalable unknown malware detection for ALL of your files
      </p>
      {isError && (
        <div className="error-container">
          <h2
            className="flex-justify-center error"
            style={{ alignItems: "center" }}
          >
            <WarningOutlined style={{ fontSize: "28px", marginRight: "8px" }} />
            {errorMsg
              ? `Error - ${errorMsg}`
              : "Sorry, the analysis could not be loaded"}
          </h2>
          <Link to="/" id="home-lnk" className="go-home-button">
            Go back to homepage
          </Link>
        </div>
      )}
    </div>
  );
};

export default UrlAnalysisHeader;
